/**
 * Shape used by the V2G assessor homepage KPI card.
 *
 * The V2G assessor view itself is just the EVAC device register with
 * `device_type=V2G` + `compliance_status=Awaiting assessment` filters deep-linked
 * in. This mapper exists only to extract the count for the dashboard tile.
 */
export interface IV2gSearchResults {
    totalResults: number
}

// Raw response shape from the API
interface IRawSearchResult {
    total_results: number
    query_results: number
    data: Record<string, string>[]
}

/**
 * Maps EVAC (LCT) search-protected response into the V2G assessor KPI shape.
 *
 * Backend filters by V2G_Capability via `device_type=V2G`. We then narrow to
 * rows where V2G_TTRStatus is populated (EVCP actually linked to a TTR
 * inverter) to derive the count shown on the assessor dashboard.
 */
export const mapEvacToV2g = (response: unknown): IV2gSearchResults => {
    const res = response as IRawSearchResult
    if (!Array.isArray(res.data)) {
        throw Error("Invalid EVAC search response")
    }

    const totalResults = res.data.filter(
        (result) =>
            result.V2G_TTRStatus !== null &&
            result.V2G_TTRStatus !== undefined &&
            result.V2G_TTRStatus !== ""
    ).length

    return { totalResults }
}
